export const SpinnerVariant = {
  default: 'default',
  white: 'white',
} as const
